export function signUp () {
  return (dispatch, getState, { clientEventManager }) => {
    const eventProps = {
      entry_point: 'sign_up_home',
    }
    clientEventManager.logEvent('login_tapped', eventProps)
    window.location.href = '/auth/signup'
  }
}

export function logIn () {
  return (dispatch, getState, { clientEventManager }) => {
    const eventProps = {
      entry_point: 'log_in_home',
    }
    clientEventManager.logEvent('login_tapped', eventProps)
    window.location.href = '/auth/login'
  }
}



// WEBPACK FOOTER //
// ./src/services/landing/actions.js